// extracted by mini-css-extract-plugin
export default {"renewDialogContent":"styles_renewDialogContent__x1ZQs","renewDialogButtons":"styles_renewDialogButtons__EZFCZ"};